import React from "react";


export default function MapPinHoverPopUp({
    title,
    description,
    left,
    top,
    display
})
{

    //--------------------------------------------------------
    // Container
    //--------------------------------------------------------

    const thisContainer =
    {
        position:
            "absolute",

        width:
            "250px",

        minHeight:
            "80px",

        display:
            "flex",

        flexDirection:
            "column",

        borderRadius:
            "0px",

        //----------------------------------------------------
        // New graphite OmniScan structure
        //----------------------------------------------------

        background:
            `linear-gradient(
                135deg,
                #292d31 0%,
                #1b1f22 52%,
                #0d0f11 100%
            )`,

        border:
            "1px solid rgba(255,255,255,0.10)",

        //----------------------------------------------------
        // Small OmniScan action/accent colour
        //----------------------------------------------------

        borderBottom:
            "2px solid rgba(69,175,224,0.70)",

        boxShadow:
            "0 8px 22px rgba(0,0,0,0.26)",

        zIndex:
            "80000",

        paddingTop:
            "10px"
    };


    //--------------------------------------------------------
    // Title
    //--------------------------------------------------------

    const titleContainer =
    {
        display:
            "flex",

        width:
            "calc(100% - 24px)",

        height:
            "24px",

        marginLeft:
            "12px",

        marginRight:
            "12px",

        alignItems:
            "center",

        justifyContent:
            "center",

        fontSize:
            "12px",

        fontWeight:
            "600",

        color:
            "#ffffff",

        borderBottom:
            "1px solid rgba(255,255,255,0.10)"
    };


    //--------------------------------------------------------
    // Description
    //--------------------------------------------------------

    const descriptionContainer =
    {
        display:
            "flex",

        width:
            "calc(100% - 20px)",

        padding:
            "10px",

        fontSize:
            "12px",

        lineHeight:
            "1.45",

        color:
            "rgba(255,255,255,0.70)"
    };


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div
            style={{
                ...thisContainer,
                left: left,
                top: top,
                display: display
            }}
        >

            <div style={titleContainer}>

                {title}

            </div>

            <div style={descriptionContainer}>

                {description}

            </div>

        </div>

    );
}